import React, { Component } from 'react';

import { getLanguages, findLanguage } from './Languages';

import './LanguageSelectBox.css';

class LanguageSelectBox extends Component {

  static defaultProps = {
    onChangeSelection : () => {
      console.error("LanguageSelectBox onChangeSelection is ", undefined, " or", null);
    },
    defaultLanguageCode : "ko",
  }

  constructor(props) {
    super(props);

    this.state = {
      languages : getLanguages(),
      selected_language : 'ko',
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextState.selected_language !== this.state.selected_language) {
      return true;
    }
    return false;
  }

  // shouldComponentUpdate(nextProps, nextState) {
  //   if (true) {

  //   }
  // }

  handleOnChangeSelection = (e) => {
    const { value } = e.target;
    const selectedLdanguage = findLanguage(value);
    this.setState({
      selected_language : selectedLdanguage.code,
    })
    this.props.onChangeSelection(selectedLdanguage.code);
  }

  itIsSelected = (value) => {
    // if (typeof this.props.defaultLanguageCode === 'object') {
    //   if (this.props.defaultLanguageCode.code === value) {
    //     return true;
    //   } else {
    //     return false
    //   }
    // } else { // String code
      if (this.props.defaultLanguageCode === value) {
        return true;
      } else {
        return false
      }
    // }
  }

  render() { 
    return (
      <select className="select-lang-list" title="언어 리스트"
        onClick={e => {e.stopPropagation()}}
        onChange={this.handleOnChangeSelection}>
        {
          this.state.languages.map( lang => (
            <option className="langauge-opt" value={lang.code} selected={this.itIsSelected(lang.code)} > 
              { lang.lang_KOR }({lang.code})
            </option>
          ))
        }
      </select>
    );
  }
}
 
export default LanguageSelectBox;